import React from 'react';

function Expiration() {

    return (
        <>
            <div className="text-align-center pad-4-tb">
                We're sorry, we are unable to retrieve your application.
            </div>
            <div className="text-align-center pad-1">
                <strong>
                    Please return to the American&nbsp;Express&#174; India Home Page to begin a new application.
                    Thank you and sorry for the inconvenience.
                </strong>
            </div>
            <div className="col-md-12 text-align-center pad-1 nav-link">
                <a className="nav-link" href="https://mediacampaigns.americanexpress.com/">
                    RETURN TO HOMEPAGE
                </a>
            </div>
        </>
    );

}

export default Expiration;